<a routerLink="/" class="sidenav-logo">
    <svg width="46" height="46" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="rgba(255,255,255,0.10)"/>
        <path d="M36 0L36 36L0 36Z" fill="#F0802A" fill-opacity="0.20"/>
        <path d="M9 7C9 12.5 18 15.8 18 17C18 18.2 9 21.5 9 27" stroke="#F0802A" stroke-width="2.5" fill="none" stroke-linecap="round"/>
        <path d="M27 7C27 12.5 18 15.8 18 17C18 18.2 27 21.5 27 27" stroke="#F4A96A" stroke-width="2.5" fill="none" stroke-linecap="round"/>
        <line x1="9" y1="12.5" x2="27" y2="12.5" stroke="rgba(255,255,255,0.25)" stroke-width="1.4" stroke-linecap="round"/>
        <line x1="9" y1="17"   x2="27" y2="17"   stroke="rgba(255,255,255,0.35)" stroke-width="1.4" stroke-linecap="round"/>
        <line x1="9" y1="21.5" x2="27" y2="21.5" stroke="rgba(255,255,255,0.25)" stroke-width="1.4" stroke-linecap="round"/>
    </svg>
    <div class="logo-texts">
        <span class="logo-name">DNA</span>
        <span class="logo-sub">Specialty</span>
    </div>
</a>

<div class="sidenav-menu-outer">
    <p class="nav-label">Navegação</p>
    <div id="vertical-menu">
        <app-vertical-menu [menuItems]="menuItems" [menuParentId]="0"></app-vertical-menu>
    </div>
</div>

<div class="sidenav-footer">
    <span class="footer-dot"></span>
    <span class="footer-text">s-audit</span>
</div>
